import axios, { AxiosError } from 'axios'
import config from 'config'

import { OctaneLogger } from '../../integrations/datadog/OctaneLogger'
import { defaultLosJsonHeaders } from '../requestHeaders'

interface Response {
    status?: string
    lead_uuid?: string
    backend_product_intent?: object
}

export default async function getBackendProductIntent(
    applicationUuid: string,
    abortController: AbortController,
) {
    try {
        if (!applicationUuid) {
            throw new Error('invalid UUID')
        }

        const { data } = await axios.get(
            `${config.API_BASE_URL}/api/v3/applications/${applicationUuid}/backend-product-intent/`,
            {
                signal: abortController.signal,
                withCredentials: true,
                headers: defaultLosJsonHeaders(),
            },
        )

        return data
    } catch (error) {
        const axiosError = error as AxiosError<Response>

        // if the applications don't have a lead linked
        if (axiosError.response?.data?.status) return axiosError.response?.data

        OctaneLogger.axiosError(
            `Failed to get backend product intents: ${axiosError.message}`,
            axiosError,
            { applicationUuid },
        )

        throw axiosError
    }
}
